import { useEffect, useState } from "react";
import Footer from "./Footer";
import StudentFooter from "./StudentFooter";
import HeaderPath from "./HeaderPath";

const Layout = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    setUser(storedUser ? JSON.parse(storedUser) : null);
  }, []);

  return (
    <>
      <HeaderPath />
      {children}
      {!user?.id ? <Footer /> : <StudentFooter />}
    </>
  );
};

export default Layout;
